// src/components/admin/portfolio/AdminPortfolioManager.jsx 
import React, { useState, useEffect } from 'react'; 
import { Link, useNavigate} from 'react-router-dom';
import fetchData from '../../../api/fetchData'; 
import { useTranslation } from 'react-i18next';

function AdminPortfolioManager({ onContentUpdated }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [portfolioList, setPortfolioList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Обернем загрузку в функцию, чтобы ее можно было вызвать повторно
  const loadList = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchData('/admin/portfolio/admin_get_all_portfolio_items.php', 'GET', null, {credentials: 'include'});
      if (response && response.status === 'success') {
        setPortfolioList(response.items || []);
      } else {
        setError(response?.message || 'Failed to load portfolio list.');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadList();
  }, []);

   const handleAddNew = () => {
  navigate('/admin/portfolio/add');
  };

  const handleDelete = async (itemId, itemTitle) => {
    
    if (window.confirm(`Вы уверены, что хотите удалить проект "${itemTitle}" (ID: ${itemId})? Это действие необратимо.`)) {
      try {
        const response = await fetchData(
          '/admin/portfolio/admin_delete_portfolio_item.php', 
          'POST', 
          { itemId: itemId },
          { credentials: 'include' }
        );
        if (response && response.status === 'success') {
          alert(response.message); 
          loadList(); 
          
       if (onContentUpdated) {
            console.log("AdminPortfolioManager: Вызываю onContentUpdated для обновления всего сайта...");
            onContentUpdated(); 
          }
        } else {
          alert(`Ошибка при удалении: ${response?.message}`);
        }
      } catch (err) {
        alert(`Критическая ошибка при удалении: ${err.message}`);
      }
    }
  };

  if (loading) return <p>{t('messages.loading')}</p>;
  if (error) return <p>{t('messages.error.generic', { details: error })}</p>;

  return (
      <div className="admin-portfolio-manager">
      <h4>{t('admin.portfolio.managerTitle', 'Управление Портфолио')}</h4> 
      <button onClick={handleAddNew} style={{ marginBottom: '20px' }}>
        {t('admin.portfolio.addNewButton', 'Добавить новый проект')}
      </button>
      {portfolioList.length === 0 ? (
        <p>{t('admin.portfolio.noItems', 'Проектов в портфолио пока нет.')}</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>{t('admin.portfolio.idLabel')}</th>
              <th>{t('admin.portfolio.titleLabel', 'Заголовок')} (RU)</th>
              <th>{t('admin.portfolio.actionsLabel', 'Действия')}</th> 
            </tr>
          </thead>
          <tbody>
            {portfolioList.map(item => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.title}</td>
                <td>
                  <Link to={`/admin/portfolio/edit/${item.id}`}>
                    {t('admin.buttons.edit', 'Редактировать')}
                  </Link>
                                    <button 
                    onClick={() => handleDelete(item.id, item.title)} 
                    className="delete-button"
                  >
                    {t('admin.buttons.delete', 'Удалить')} 
                    {/* Добавь ключ admin.buttons.delete в JSON */}
                  </button>

                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AdminPortfolioManager;